import { useEffect, useState } from "react";
import useOrder from "../hooks";
import {
  ProductSelectBox,
  ProductSelectCountBox,
  ProductSelectCountBoxWrapper,
  ProductSelectHeader,
  ProductSelectInfo,
  ProductSelectLeftButton,
  ProductSelectRightButton,
  ProductSelectButtonWrapper,
  ProductSelectWrapper,
} from "./styles/product-select";
import {
  PayPubProductDto,
  PubProductResponse,
} from "../../../../../../api/pub-product";

const ProductSelect = ({
  product,
  setSelectedProduct,
  cart,
  setCart,
}: {
  product: PubProductResponse;
  setSelectedProduct: (product: PubProductResponse | null) => void;
  cart: PayPubProductDto[];
  setCart: (cart: PayPubProductDto[]) => void;
}) => {
  const [count, setCount] = useState(1);

  const addCart = async () => {
    const findItem = cart.find((item) => item.pubProductId === product.id);
    if (findItem) {
      setCart(
        cart.map((item) =>
          item.pubProductId === product.id
            ? { ...item, count: item.count + count }
            : item
        )
      );
    } else {
      setCart([...cart, { pubProductId: product.id, count }]);
    }
    setSelectedProduct(null);
  };

  const handleMinus = () => {
    if (count > 1) {
      setCount(count - 1);
    }
  };

  const handlePlus = () => {
    setCount(count + 1);
  };

  return (
    <ProductSelectWrapper>
      <ProductSelectBox>
        <ProductSelectHeader>
          <ProductSelectInfo>
            <div className="row">
              <div className="title">{product?.name}</div>
              <div className="value">{product?.price.toLocaleString()} M</div>
            </div>
            <ProductSelectCountBoxWrapper>
              <ProductSelectCountBox width="25px">
                <img
                  src="/image-web/order/minus.svg"
                  alt="minus"
                  onClick={handleMinus}
                />
              </ProductSelectCountBox>
              <ProductSelectCountBox width="52px">
                {count}
              </ProductSelectCountBox>
              <ProductSelectCountBox width="25px">
                <img
                  src="/image-web/order/plus.svg"
                  alt="plus"
                  onClick={handlePlus}
                />
              </ProductSelectCountBox>
            </ProductSelectCountBoxWrapper>
          </ProductSelectInfo>
          <img
            src={product?.imageUrl ?? "/image-web/order/alcohol-default.png"}
            alt={product?.name}
          />
        </ProductSelectHeader>
        <ProductSelectButtonWrapper>
          <ProductSelectLeftButton onClick={() => setSelectedProduct(null)}>
            취소
          </ProductSelectLeftButton>
          <ProductSelectRightButton onClick={addCart}>
            장바구니 담기
          </ProductSelectRightButton>
        </ProductSelectButtonWrapper>
      </ProductSelectBox>
    </ProductSelectWrapper>
  );
};

export default ProductSelect;
